import { MessagesSquare } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { EmptyState, EmptyStateCircles, EmptyStateContent, EmptyStateDescription, EmptyStateFooter, EmptyStateTitle } from '@/components/ui/empty-state';
import { FeaturedIcon } from '@/components/ui/featured-icon';

interface ChatIndexEmptyProps {
  openCreateConversation: () => void;
}

export default function ChatIndexEmpty(chatIndexEmptyProps: ChatIndexEmptyProps) {
  const { openCreateConversation } = chatIndexEmptyProps;
  return (
    <div className={'md:bg-background flex grow items-center justify-center md:rounded-2xl md:border md:p-4'}>
      <EmptyState>
        <EmptyStateCircles className={'z-0'} />
        <FeaturedIcon size={'lg'} className={'z-10'}>
          <MessagesSquare />
        </FeaturedIcon>
        <EmptyStateContent>
          <EmptyStateTitle>Utwórz konwersację</EmptyStateTitle>
          <EmptyStateDescription>
            Aby skontaktować się z dowolnym użytkownikiem,
            <br />
            naciśnij przycisk “Utwórz konwersację”
            <br />i wyszukaj użytkownika i pytaj o co chcesz.
          </EmptyStateDescription>
          <EmptyStateFooter>
            <Button onClick={openCreateConversation} variant={'outline'}>
              Utwórz konwersację
            </Button>
          </EmptyStateFooter>
        </EmptyStateContent>
      </EmptyState>
    </div>
  );
}
